<!-- =========================================================================================
    File Name: TableStriped.vue
    Description: Rendering default table with striped style
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <vx-card title="Captura de calificaciónes Estancias/Estadias" code-toggler>
      <p>{{cuatrimestre_actual[0].nombre}} {{cuatrimestre_actual[0].idAgno}}</p><br>


        <div class="">



        </div>
        <vs-table stripe :data="calificaciones">

            <template slot="thead">
                <vs-th>Matricula</vs-th>
                <vs-th>Alumno</vs-th>
              <vs-th>Materia</vs-th>
                <vs-th>Calificación</vs-th>
                <vs-th>Acciones</vs-th>
            </template>

            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td :data="data[indextr].id">
                        {{data[indextr].matricula}}
                    </vs-td>
                    <vs-td :data="data[indextr].id">
                      {{data[indextr].apellidoPaterno}} {{data[indextr].apellidoMaterno}} {{data[indextr].nombres}}
                    </vs-td>
                    <vs-td :data="data[indextr].id">
                    {{data[indextr].nmateria}}
                </vs-td>
                    <vs-td :data="data[indextr].id">

                        <vs-input v-if="data[indextr].calificacionFinal == null" style="width: 150px;" v-model="data[indextr].calificacion" />
                        <div v-else>
                            {{data[indextr].calificacionFinal}}
                        </div>

                    </vs-td>

                    <vs-td style="width: 240px;" :data="data[indextr].id">
                        <vs-button style=""  v-if="data[indextr].calificacionFinal == null" @click="guardar_calif(data[indextr])" color="primary" type="filled">Guardar</vs-button>
                        <vs-button style="margin-left: 5px;" v-if="data[indextr].calificacionFinal == null" @click="enviar_calif(data[indextr])" color="warning" type="filled">Enviar</vs-button>
                    </vs-td>

                </vs-tr>
            </template>
        </vs-table>
        <vs-button  style="margin: 5px;" @click="genera_acta()" color="success" type="filled">Generar acta</vs-button>
    </vx-card>
</template>

<script>
    import vSelect from 'vue-select'

    export default {
        computed:{


        },
        data() {
            return {
              id: localStorage.getItem('id'),
              cuatrimestre_actual: [{ nombre: "", idAgno: "" }],
              calificaciones: [],

            }
        },

      created() {
        this.getCuatrimestreActual();
      },
        components: {
            'v-select': vSelect,
        },
        filters: {

        },
        methods: {
          getCuatrimestreActual(){
            this.$http.get("cuatrimestre_actual").then(
                response => {
                  // console.log(response.data)
                  this.cuatrimestre_actual = response.data.cuatrimestre_actual;
                  //console.log(this.kardex);
                  this.getAlumnosGrupo();
                  //
                  //

                },
                error => {
                  this.StepError(error);
                }
            );
          },

            guardar_calif(fila){

            console.log(fila)

              this.$http.post("guardar_calificaciones_estancia",
                  {calificacion: fila}).then(
                  response => {
                    //  location.reload();
                    // console.log(response.data)
                    this.getAlumnosGrupo()
                    this.$vs.notify({
                      color: 'danger',
                      title: 'Información guardada',
                      text: 'Se ha guardado la información'
                    })
                    //this.alumnos_grupo = response.data.alumnos_grupo;
                    //console.log(this.kardex);

                  },
                  error => {
                    this.StepError(error);
                  }
              );


            },

            enviar_calif(fila){


              this.guardar_calif(fila);
              this.$http.get("enviar_calificaciones_estancia/" + fila.nidAlumno + "/" + fila.nidGrupo).then(
                  response => {
                    // console.log(response.data)
                    // this.alumnos_grupo = response.data.alumnos_grupo;
                    //console.log(this.kardex);
                    this.getAlumnosGrupo();
                  },
                  error => {
                    this.StepError(error);
                  }
              );


/*
                console.log(this.alumnos_grupo);


                */

            },
            genera_acta(){
              //  console.log(this.alumnos_grupo);
                window.open('https://cdn.upbicentenario.edu.mx/api/acta_calificaciones_estancias/' + this.id)

            },

            getAlumnosGrupo() {
                this.$http.get("calificaciones_estancias_estadias/" + this.id + "/" + this.cuatrimestre_actual[0].idAgno + "/" + this.cuatrimestre_actual[0].idPeriodo).then(
                    response => {
                        // console.log(response.data)
                        this.calificaciones = response.data.calificaciones;

                    },
                    error => {
                        this.StepError(error);
                    }
                );
            },


        },
    }
</script>
